import { useParams, useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'

import { Wrapper, AppBarR as PersistentDrawerRight } from '../components/common'
import { CreateDesk } from '../components/desk'
import db from '../db/db'
import { sessionState } from '../state'

import routes from './routes'

/**
 * CreateDeskPage - Page component for desk creation
 *
 * Handles both regular desk creation and desk creation with pre-selected office.
 * When officeId is provided in URL params, the office selection is pre-filled and disabled.
 *
 * Requirements: 7.2, 7.3, 7.4
 */
const CreateDeskPage = () => {
  const [userState, setUserState] = useRecoilState(sessionState)
  const { officeId } = useParams<{ officeId?: string }>()
  const navigate = useNavigate()

  // Find the pre-selected office if officeId is provided
  const preSelectedOffice = officeId
    ? userState.offices?.find(office => office.oid === officeId)
    : null

  const reloadDesks = async () => {
    if (userState.user) {
      // Reload the session to get updated desk list
      const updatedDesks = await db.query({
        collection: 'desks',
        where: ['uid', '==', userState.user.uid]
      })

      setUserState(old => ({
        ...old,
        desks: updatedDesks
      }))
    }
  }

  const handleDeskCreated = async () => {
    await reloadDesks()
    // Navigate back to offices page after successful creation
    navigate(routes.offices)
  }

  const handleCancel = () => {
    // Navigate back to appropriate page based on context
    if (officeId) {
      // If we came from office creation, go back to profile
      navigate(routes.profile)
    } else {
      // Otherwise go to offices page
      navigate(routes.offices)
    }
  }

  return (
    <>
      <PersistentDrawerRight />
      <Wrapper>
        {userState.user && (
          <CreateDesk
            user={userState.user}
            onCreate={handleDeskCreated}
            onUpdate={() => {}}
            desk={null}
            preSelectedOffice={preSelectedOffice}
            onCancel={handleCancel}
          />
        )}
      </Wrapper>
    </>
  )
}

export default CreateDeskPage
